<div class="modal-header">
  <h4 class="modal-title">Select an Address</h4>
  <aurora-icon-button class="close" type="button" (click)="cancelSelection()" icon="times" size="large"></aurora-icon-button>
</div>
<div class="table-responsive">
  <table class="table table-select table-fixed-header" style="width: 100%; overflow-x: auto; white-space: nowrap">
    <tr>
      <th>Default</th>
      <th>Address Type</th>
      <th>Address Line 1</th>
      <th>Address Line 2</th>
      <th>Address Line 3</th>
      <th>Zip</th>
      <th>City</th>
      <th>State</th>
      <th>County</th>
      <th>Country</th>
    </tr>
    <tr
      *ngFor="let address of addresses; index as i"
      (click)="app.getSelectedText() && onSelect(address)"
      style="cursor: pointer"
    >
      <td>
        <i
          [class]="address.Dflt_Address_Ind == 'Y' ? 'fa fa-ep-selected-square' : 'fa fa-ep-selected-false-square'"
        ></i>
      </td>
      <td>{{ address.Address_Type_Desc }}</td>
      <td>{{ address.Address_Line_1 }}</td>
      <td>{{ address.Address_Line_2 }}</td>
      <td>{{ address.Address_Line_3 }}</td>
      <td>{{ address.Zip }}</td>
      <td>{{ address.City }}</td>
      <td>{{ address.State }}</td>
      <td>{{ address.County }}</td>
      <td>{{ address.Country }}</td>
    </tr>
  </table>
</div>
<div class="modal-footer">
  <aurora-button type="button" (click)="cancelSelection()" variant="primary">Cancel</aurora-button>
</div>
